import React, { useEffect, useRef } from "react";
import RegFormCustomer from "./RegFormCustomer";
import HeaderCustomer from "./HeaderCustomer";
import Layout from "../Layout";

const RegCustomer = () => {
    const topRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            const title = document.querySelector("#CustomerLevelTitle");
            if (!title) {
                return;
            }

            title.scrollIntoView({ behavior: "smooth" });
            title.setAttribute("tabindex", "-1");
            title.focus();
        }, 500);

        return () => clearTimeout(timer);
    }, []);
    return (
    <Layout>
        <HeaderCustomer />
        <main className="layout-container">
            <div 
                className="container"
                ref={topRef}
                tabIndex="-1"
             >
                <div className="descript-container container-2">
                    <h1 className="form-title g-clr"  id="CustomerLevelTitle">Customer Registration</h1>
                    <p>
                    Fill out the form below to set up a new customer account according to their requirements.
                    </p>
                </div>
                <RegFormCustomer />
            </div>
        </main>
    </Layout>
    )
};

export default RegCustomer;
